module.exports = __webpack_public_path__ + "c635a668a2aae61cdee53ccfe09f0a57.png";